var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "InPlayerVideoOverlay",
    [
      _c(
        "OverlayContent",
        { attrs: { icon: _vm.icon, "icon-alignment": _vm.iconAlignment } },
        [
          _vm.shouldRender("title")
            ? _c("template", { slot: "title" }, [
                _c("span", { class: _vm.$style.multiLine }, [
                  _vm._v(_vm._s(_vm.$t("title")))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.shouldRender("message")
            ? _c("template", { slot: "message" }, [
                _c("span", { class: _vm.$style.multiLine }, [
                  _vm._v(_vm._s(_vm.$t("message")))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("ActionDescriptorsRenderer", {
            attrs: {
              slot: "content",
              translator: _vm.translator,
              descriptors:
                _vm.overlay.presentation &&
                _vm.overlay.presentation.descriptor &&
                _vm.overlay.presentation.descriptor.action
            },
            on: { "action-click": _vm.handleActionClick },
            slot: "content"
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.isDismissable && _vm.shouldRender("dismiss")
        ? _c(
            "FooterAction",
            {
              attrs: { slot: "footer" },
              on: {
                click: function() {
                  return _vm.dismiss({ autoplay: true })
                }
              },
              slot: "footer"
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("dismiss")) + "\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }